import utils from "../utils";

function init() {

	var accordions = document.querySelectorAll(".accordion-wrapper");

	if(accordions.length > 0){
		utils.forEach(accordions, function (index, accordion) {

			accordion.addEventListener("click", function () {

				if(accordion.classList.contains('open')){
					accordion.classList.remove('open');
				} else {
					closeOtherAccordions(accordions);
					accordion.classList.add('open');
				}
				
			});

		});
	}
}

function closeOtherAccordions(accordions) {
	utils.forEach(accordions, function (index, accordion) {
		accordion.classList.remove('open');
	})
}

export default { init };
